export default {
  appName: {
    full: '平安成电智慧通行管理系统',
    subTitle: '电子科技大学',
    attr: '平安成电智慧通行',
    logoPath: '',
  },
  version: '2.1.3',
  permissionSeq: ':',
  navDrawerWidth: 256,
  clipped: true,
  toolbarColor: 'blue-grey darken-3',
  darkToolbar: true,
  darkNavDrawer: false,
  // navDrawerColor: 'white',
  denseNavDrawer: false,
  icons: {
    'person': 'mdi-account',
    'role': 'mdi-account-box',
    'group': 'mdi-account-multiple',
    'email': 'mdi-email',
    'idCard': 'mdi-credit-card',
    'idCardType': 'mdi-credit-card-settings',
    'phone': 'mdi-phone',
    'org': 'mdi-bank',
    'loginId': 'mdi-account-card-details',
    'message': 'mdi-message-text',
    'description': 'mdi-file-document',
    'car': 'mdi-car',
    'add': 'mdi-plus',
    'delete': 'mdi-delete',
    'more': 'mdi-dots-vertical',
    'deleteAll': 'mdi-delete-sweep',
    'lock': 'mdi-lock',
    'back': 'mdi-arrow-left',
    'code': 'mdi-code-tags',
    'alert': 'mdi-alert-circle',
    'comment': 'mdi-message-text',
    'location': 'mdi-map-marker',
    'edit': 'mdi-pencil',
    'folder': 'mdi-folder',
    'chevronRight': 'mdi-chevron-right',
    'chevronLeft': 'mdi-chevron-left',
    'details': 'mdi-dots-horizontal',
    'letter': 'mdi-phone-log',
    'arrowRight': 'mdi-arrow-right',
    'arrowLeft': 'mdi-arrow-left',
    'shiroStr': 'mdi-format-color-text',
    'permission': 'mdi-lock',
    'parkingLot': 'mdi-parking',
    'controller': 'mdi-navigation',
    'levelCode': 'mdi-barcode',
    'level': 'mdi-sort-variant',
    'institution': 'mdi-bank',
    'password': 'mdi-lock',
    'passwordReset': 'mdi-lock-reset',
    'lockReset': 'mdi-lock-reset',
    'lockOutline': 'mdi-lock-outline',
    'groupParent': 'mdi-account-group',
    'audio': 'mdi-volume-high',
    'led': 'mdi-monitor',
    'title': 'mdi-format-title',
    'standalone': 'mdi-star',
    'info': 'mdi-information-outline',
    'timer': 'mdi-timer',
    'severity': 'mdi-alert-octagon'
  },
}
